import constants from '@/lib/constants.js'
import _config from '@/config.js'

let config = _config[process.env.NODE_ENV || 'development']

export default {
  data() {
    return {
      constants: constants,
      config: config
    }
  }
}
